var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, css, html } from 'lit';
import { SHARED_STYLES } from '../css/shared-css.js';
import { customElement, property } from 'lit/decorators.js';
const CYAN = 120;
const DEFAULT_MAX = 7;
let ChromedashColorStatus = class ChromedashColorStatus extends LitElement {
    constructor() {
        super(...arguments);
        this.max = DEFAULT_MAX;
    }
    static get styles() {
        return [
            ...SHARED_STYLES,
            css `
        span {
          background-color: rgb(255, 0, 0);
          border-radius: 50%;
          display: inline-block;
          height: 10px; /* Default. */
          width: 10px; /* Default. */
        }

        :host(.corner) {
          height: 100%;
        }
        :host(.corner) #status {
          border-radius: 0;
          height: 100%; /* Ensures we can color coverage when feature is scrolled.*/
          width: 4px;
        }

        :host(.bottom) {
          height: 8px;
          width: 100%;
          position: absolute;
          bottom: 0;
          left: 0;
        }
        :host(.bottom) #status {
          border-radius: 0;
          height: 100%;
          width: 100%;
        }
      `,
        ];
    }
    render() {
        const color = `hsl(${Math.round(CYAN - (this.value * CYAN) / this.max)}, 100%, 50%)`;
        return html ` <span id="status" style="background-color: ${color}"></span> `;
    }
};
__decorate([
    property({ type: Number })
], ChromedashColorStatus.prototype, "max", void 0);
__decorate([
    property({ type: Number })
], ChromedashColorStatus.prototype, "value", void 0);
ChromedashColorStatus = __decorate([
    customElement('chromedash-color-status')
], ChromedashColorStatus);
